import type { Countdown } from "./countdown.types";

const STORAGE_KEY = "saradium-countdowns";

export function loadCountdowns(): Countdown[] {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);

    if (!saved) {
      return [];
    }

    const parsed: unknown = JSON.parse(saved);

    return Array.isArray(parsed)
      ? (parsed as Countdown[])
      : [];
  } catch {
    return [];
  }
}

export function saveCountdowns(
  countdowns: Countdown[],
): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(countdowns),
  );
}